var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
// md3: reuses the SAME "Finde dein Auto" hero-search block/styles as the homepage's
// HeroOfferSlider (NewMainPage.tsx, `.mcard hero-search co-hero-search` + `.field-grid-2`) —
// same 4 fields (Marke/Modell/Rate bis/km bis via searchable Dropdown with icons), same CTA/
// "Weitere Suchoptionen"/stars footer — instead of the old compact package SearchBox panel.
import { Button, Dropdown, Stars } from '@bytebrand/fe-ui-core-autobahn/ui';
import { buildQueryForSearch, buildBodyForRequest } from '@bytebrand/fe-ui-core-autobahn/utils';
import { MANUFACTURER_KEY, MODEL_KEY, MILEAGE_KEY, RATE_KEY, OBJECT_FILTERS, THROTTLE_DELAY, } from '../../../framework/constants/search';
import { HERO_RATES, HERO_KM } from '../NewMainPage/newMainData';
import { inject, observer } from 'mobx-react';
const RATE_DEFAULT = OBJECT_FILTERS[RATE_KEY].defaultValue;
// model lists mix a selectable SERIES row with models of the same title ('Golf'), and the
// md3 Dropdown identifies options by value — same marker trick as the homepage hero search.
const SERIES_PREFIX = '⁣series⁣';
const deNum = (n) => n.toLocaleString('de-DE');
/**
 * A SET monthly-rate filter value — mirrors NewMainPage's rateFilterValue. firstInstallment/
 * paybackPeriod must carry the SRP defaults (0 / 60) so the SRP can hydrate the query.
 */
const rateFilterValue = (rate) => ({
    monthlyInstallmentFrom: '', monthlyInstallmentTo: rate, firstInstallment: 0, paybackPeriod: 60,
});
/**
 * count/car body honoring the rate: RATE goes through `filters.ignoredValues.RATE`, which
 * SearchAPI.getCount's transformRateToPrice converts into a price range — same as NewMainPage's
 * countBodyFor (buildBodyForRequest's own RATE branch is a broken stub).
 */
const countBodyFor = (filters) => {
    const body = buildBodyForRequest({ ...filters, [RATE_KEY]: null });
    const rate = filters[RATE_KEY];
    if (rate && rate.monthlyInstallmentTo) {
        body.filters.ignoredValues = { [RATE_KEY]: rate };
    }
    return body;
};
let timeout = null;
let NotFoundSearchWidget = class NotFoundSearchWidget extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "encodeValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (o) => (o && o.isSeries ? SERIES_PREFIX : '') + String(o && o.value)
        });
        Object.defineProperty(this, "commitOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (name, source) => (next) => {
                if (!next) {
                    this.onFilterChange('', name);
                    return;
                }
                const match = source.find((o) => this.encodeValue(o) === next);
                this.onFilterChange(match
                    ? { value: match.value, label: match.label, ...(match.isSeries ? { isSeries: true } : {}) }
                    : { value: next, label: next }, name);
            }
        });
        Object.defineProperty(this, "onFilterChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value, name) => {
                if (!name)
                    return false;
                const newState = Object.assign({}, this.state);
                newState.filters[name] = value;
                if (name === MANUFACTURER_KEY) {
                    newState.filters[MODEL_KEY] = '';
                    this.getModels(value.value);
                }
                this.setState(() => (newState), () => {
                    clearTimeout(timeout);
                    timeout = setTimeout(this.getCarsCounter, THROTTLE_DELAY);
                });
            }
        });
        Object.defineProperty(this, "onSearchButtonClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { filters } = this.state;
                const query = buildQueryForSearch(filters);
                const resolvePrefix = query ? `/search?${query}` : '/search';
                this.onChangeLocation(resolvePrefix);
            }
        });
        Object.defineProperty(this, "onDetailedSearchClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.onChangeLocation('/search/detailed')
        });
        Object.defineProperty(this, "onChangeLocation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path) => this.props.onRedirect(path)
        });
        Object.defineProperty(this, "getManufacturers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { appStore } = this.props;
                appStore.getManufacturers(true)
                    .then((manufacturers) => {
                    this.updateManufacturersList(manufacturers);
                });
            }
        });
        Object.defineProperty(this, "getModels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (maker) => {
                const { appStore } = this.props;
                appStore.getModelsInfoByMaker(maker, true)
                    .then((models) => {
                    this.setState(() => ({
                        models
                    }));
                });
            }
        });
        Object.defineProperty(this, "getCarsCounter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { searchStore } = this.props;
                const { filters } = this.state;
                this.setState(() => ({ counterLoading: true }));
                searchStore.getCount(countBodyFor(filters), true)
                    .then((res) => {
                    this.updateCarCounter(res);
                });
            }
        });
        Object.defineProperty(this, "updateManufacturersList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (manufacturers) => this.setState(() => ({
                manufacturers
            }))
        });
        Object.defineProperty(this, "updateCarCounter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (counter) => this.setState(() => ({
                counter,
                counterLoading: false
            }))
        });
        this.state = {
            counter: 0,
            counterLoading: true,
            manufacturers: [],
            models: [],
            filters: {
                [MANUFACTURER_KEY]: '',
                [MODEL_KEY]: '',
                [MILEAGE_KEY]: '',
                [RATE_KEY]: { ...RATE_DEFAULT },
            }
        };
    }
    componentDidMount() {
        this.getCarsCounter();
        this.getManufacturers();
    }
    componentWillUnmount() {
        timeout = null;
    }
    render() {
        const { counter, counterLoading, manufacturers, models, filters } = this.state;
        const clearOption = { value: '', label: 'beliebig' };
        const toOptions = (list) => list.map((o) => ({ value: this.encodeValue(o), label: String(o.label), disabled: !!o.isDisabled }));
        const makeValue = filters[MANUFACTURER_KEY] && filters[MANUFACTURER_KEY].value != null ? String(filters[MANUFACTURER_KEY].value) : '';
        const modelValue = filters[MODEL_KEY] && filters[MODEL_KEY].value != null ? this.encodeValue(filters[MODEL_KEY]) : '';
        const rateValue = filters[RATE_KEY] && filters[RATE_KEY].monthlyInstallmentTo ? String(filters[RATE_KEY].monthlyInstallmentTo) : '';
        const kmValue = filters[MILEAGE_KEY] && filters[MILEAGE_KEY].value != null ? String(filters[MILEAGE_KEY].value) : '';
        const makeOptions = toOptions(manufacturers);
        const modelOptions = toOptions(models);
        const rateOptions = HERO_RATES.map((r) => ({ value: String(r), label: `bis ${r} €/mtl.` }));
        const kmOptions = HERO_KM.map((k) => ({ value: String(k), label: `bis ${deNum(k)} km` }));
        const totalLabel = !counterLoading && counter != null ? deNum(counter) : null;
        const ctaLabel = totalLabel ? `${totalLabel} Treffer anzeigen` : 'Treffer anzeigen';
        return (React.createElement("div", { className: "mcard hero-search", style: { padding: 24, background: 'var(--md-sc-lowest)', color: 'var(--md-on-surface)', boxShadow: '0 24px 60px rgba(4,20,50,.15)' } },
            React.createElement("div", { className: "md-title", style: { marginBottom: 6 } }, "Finde dein Auto"),
            React.createElement("div", { className: "md-body-sm", style: { marginBottom: 14 } }, totalLabel ? `${totalLabel} geprüfte Fahrzeuge sofort verfügbar` : 'Geprüfte Fahrzeuge sofort verfügbar'),
            React.createElement("div", { className: "field-grid-2" },
                React.createElement(Dropdown, { value: makeValue, options: makeOptions, onChange: this.commitOption(MANUFACTURER_KEY, manufacturers), placeholder: "Marke", icon: "car-front", ariaLabel: "Marke", searchable: true }),
                React.createElement(Dropdown, { value: modelValue, options: modelOptions, onChange: this.commitOption(MODEL_KEY, models), placeholder: "Modell", icon: "car", ariaLabel: "Modell", disabled: !makeValue, searchable: true }),
                React.createElement(Dropdown, { value: rateValue, options: rateValue ? [clearOption, ...rateOptions] : rateOptions, onChange: (next) => this.onFilterChange(next ? rateFilterValue(Number(next)) : { ...RATE_DEFAULT }, RATE_KEY), placeholder: "Rate bis", icon: "wallet", ariaLabel: "Rate bis" }),
                React.createElement(Dropdown, { value: kmValue, options: kmValue ? [clearOption, ...kmOptions] : kmOptions, onChange: (next) => this.onFilterChange(next ? { value: Number(next), label: `bis ${deNum(Number(next))} km` } : '', MILEAGE_KEY), placeholder: "km bis", icon: "gauge", ariaLabel: "km bis" })),
            React.createElement(Button, { variant: "filled", size: "lg", block: true, icon: "search", style: { marginTop: 14 }, onClick: this.onSearchButtonClick }, ctaLabel),
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginTop: 12 } },
                React.createElement("a", { className: "link-accent", style: { fontSize: 13.5, fontWeight: 600, cursor: 'pointer' }, onClick: this.onDetailedSearchClick }, "Weitere Suchoptionen")),
            React.createElement("hr", { className: "mdivider", style: { margin: '14px 0' } }),
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 } },
                React.createElement(Stars, { value: 4.7, size: 16 }),
                React.createElement("span", { className: "md-label-sm", style: { color: 'var(--md-on-surface)' } },
                    React.createElement("b", null, "4,7 / 5")))));
    }
};
Object.defineProperty(NotFoundSearchWidget, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        appStore: {},
        searchStore: {}
    }
});
NotFoundSearchWidget = __decorate([
    inject('appStore', 'searchStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], NotFoundSearchWidget);
export default NotFoundSearchWidget;
